const listeners = new Set();

export function subscribeSocialNotificationUnread(listener) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

export function notifySocialNotificationUnreadChanged() {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch {
      // ignore listener errors
    }
  });
}
